import { useStores } from 'src/common/stores';
import { usePalette } from '../hooks/usePalette';

export function withPalette(ComponentToDecorate) {
  function DecoratedComponent(props) {
    const { playerStore } = useStores();
    const nowPlaying = playerStore.metadata();
    const palette = usePalette(nowPlaying?.guideId, nowPlaying?.image);

    return <ComponentToDecorate {...props} palette={palette} />;
  }

  return DecoratedComponent;
}
